import React from "react";
import { isSegFeatureEnabled, SegFlags, translate } from "../../../../common/providers";
import styles from "./MembersListHeader.module.css";

export default function MembersListHeader() {
	return (
		<div className={styles["members-row"]}>
			<div className={styles["members-row__member-cell"]}>{translate("team-management.members.header.name")}</div>
			<div className={styles["members-row__select-cell"]}>{translate("team-management.members.header.role")}</div>
			<div className={styles["members-row__rights-on-documents"]}>
				{isSegFeatureEnabled(SegFlags.RIGHTS_ON_DOCUMENTS) &&
					translate("team-management.members.header.rights-on-documents")}
			</div>
			<div className={styles["members-row__access-cell"]}>
				{translate("team-management.members.header.access")}
			</div>
		</div>
	);
}
